export const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_SSO_CLIENT_ID ?? '';

const OAUTH_POPUP_WIDTH = 500;
const OAUTH_POPUP_HEIGHT = 600;

export const buildGoogleOAuthUrl = (): string => {
  const pathname = window.location.pathname;
  const previewPath = pathname.startsWith('/prev-')
    ? pathname.split('/').slice(0, 2).join('/')
    : '';

  const params = new URLSearchParams({
    client_id: GOOGLE_CLIENT_ID,
    redirect_uri: `${window.location.origin}${previewPath}/auth/google/callback.html`,
    response_type: 'id_token',
    scope: 'openid email profile',
    nonce: crypto.randomUUID(),
    prompt: 'select_account',
  });
  return `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`;
};

export const openCenteredPopup = (url: string, name: string): Window | null => {
  const left = window.screenX + (window.outerWidth - OAUTH_POPUP_WIDTH) / 2;
  const top = window.screenY + (window.outerHeight - OAUTH_POPUP_HEIGHT) / 2;
  return window.open(
    url,
    name,
    `width=${OAUTH_POPUP_WIDTH},height=${OAUTH_POPUP_HEIGHT},left=${left},top=${top},toolbar=no,menubar=no`,
  );
};
